
<div id="flightToolbox">
	<h1>Flight Toolbox</h1>
	<div>
		<hr />
		<button id="export3d">Beta - Show 3D Flight</button>
		<hr />
		<button id="map3d">Beta - 3D Map</button>
		<hr />
		<button id="flightLogViewerButton">Flight Log Viewer</button>
		<hr />
	</div>
</div>